module.exports = __webpack_public_path__ + "img/tab4@2x.20e945ec.png";